import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { Drawer } from "@mantine/core";
import { SubTopic, Topic } from "@tsTypes/subject-schema";
import { useCheckUserAccess } from "@utils/accessChecks";
import "katex/dist/katex.min.css";
import {
  useSubjectMeta,
  useTopicMeta,
} from "../../../../../components/CoreDataProvider";
import RestrictedResourceBanner from "../../components/banners/RestrictedResourceBanner";
import SyllabusTable from "../../syllabus/components/SyllabusTable";
import classes from "./SyllabusDrawer.module.css";

export default function SyllabusDrawer({
  subjectDocumentId,
  topicSyllabusPointData,
  drawOpen,
  close,
}: {
  subjectDocumentId: string;
  topicSyllabusPointData: {
    documentId: Topic["documentId"];
    TopicDescription: Topic["TopicDescription"];
    RelatedSubTopics: Pick<SubTopic, "documentId" | "RelatedSyllabusPoints">[];
  };
  drawOpen: boolean;
  close: () => void;
}) {
  const subjectMeta = useSubjectMeta(subjectDocumentId);
  const subjectNameLower = subjectMeta.title.toLowerCase();
  const topicMeta = useTopicMeta(topicSyllabusPointData.documentId);
  const subjectColorIndex = getSubjectColorIndex(subjectMeta.title);
  const userAccess = useCheckUserAccess("syllabus", subjectDocumentId);
  return (
    <Drawer
      className={classes.drawer}
      opened={drawOpen}
      onClose={close}
      position="right"
      size={"min(90vw, 1100px)"}
      title={`Topic ${topicMeta.number} Syllabus Checklist`}
      overlayProps={{ color: "darkblue", opacity: 0.75 }}
      closeButtonProps={{
        size: "md",
        className: classes.closeButton,
      }}
      transitionProps={{ transition: "slide-left" }}
      styles={{
        content: {
          ["--syllabus-drawer-bg" as string]: `var(--mantine-color-${subjectColorIndex}-0)`,
        } as React.CSSProperties,
      }}
    >
      <RestrictedResourceBanner
        resource={"syllabus"}
        subjectDocumentId={subjectDocumentId}
        subjectName={subjectNameLower}
        userAccess={userAccess}
      />
      <SyllabusTable
        subjectNameLower={subjectNameLower}
        subjectDocumentId={subjectDocumentId}
        topicSyllabusPointData={topicSyllabusPointData}
        withoutMargins={true}
        restrictAccess={userAccess === "Read Only"}
        className="first-table-fade-in"
      />
    </Drawer>
  );
}
